import { render, staticRenderFns } from "./WeeklyTable.vue?vue&type=template&id=4e0d6150&scoped=true"
import script from "./WeeklyTable.vue?vue&type=script&lang=js"
export * from "./WeeklyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0d6150",
  null
  
)

export default component.exports